import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const StorySection = () => {
  return <section className="py-8 space-y-8" data-id="element-269">
      <FadeIn data-id="element-270">
        <div className="bg-amber-950/40 border border-amber-900/50 rounded-xl p-6 sm:p-8" data-id="element-271">
          <h2 className="text-xl sm:text-2xl font-bold text-amber-500 mb-4 flex items-center gap-2" data-id="element-272">
            <span data-id="element-273">⚠️</span> ATENCIÓN
          </h2>
          <p className="text-lg text-slate-200 font-medium" data-id="element-274">
            Si no haces algo diferente esta noche, mañana será exactamente
            igual.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-275">
        <div className="space-y-6 text-lg text-slate-300 leading-relaxed" data-id="element-276">
          <p data-id="element-277">
            <strong className="text-white" data-id="element-278">Son las 2:14 AM.</strong> El ardor te
            despierta otra vez. Te sientas en el borde de la cama, respiras
            hondo intentando calmarte, pero el fuego en tu pecho no cede.
          </p>
          <p data-id="element-279">
            Vas a la cocina, tomas un antiácido masticable, bebes agua fría y
            esperas. Veinte minutos de alivio. Luego el fuego regresa.
          </p>
          <p data-id="element-280">
            Mañana estarás agotado, irritable, con la garganta rasposa y con esa
            niebla mental que te acompaña todo el día. Y lo peor: sabes que
            mañana por la noche volverá a ocurrir.
          </p>
        </div>
      </FadeIn>

      <FadeIn data-id="element-281">
        <div className="bg-slate-900 border-l-4 border-red-500 p-6 sm:p-8 rounded-r-xl" data-id="element-282">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-283">
            Esto no es solo incómodo. Es peligroso.
          </h3>
          <p className="text-slate-300 mb-4" data-id="element-284">
            Cada noche que el ácido sube sin control, está quemando lentamente
            el tejido de tu esófago. Los médicos tienen un nombre para lo que
            ocurre después de años de reflujo no controlado:{' '}
            <strong className="text-red-400" data-id="element-285">Esófago de Barrett</strong>.
          </p>
          <p className="text-slate-300" data-id="element-286">
            Es una condición precancerosa. Y la mayoría de las personas que la
            desarrollan pensaron exactamente lo mismo que tú:{' '}
            <em className="text-slate-400" data-id="element-287">
              "Es solo acidez, ya se me pasará."
            </em>
          </p>
        </div>
      </FadeIn>
    </section>;
};